<script setup>
import Index from "@/views/data/review/index.vue"

definePage({
  meta: {
    action: 'read',
    subject: 'data-review',
  },
})

const router = useRouter()

const tab = router.currentRoute.value.params.tab
</script>

<template>
  <Index :tab="tab" />
</template>
